import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-submenu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "submenu-header" }, "Mijn 5xbeter", -1)
const _hoisted_3 = { class: "submenu" }
const _hoisted_4 = { class: "submenu" }
const _hoisted_5 = { key: 0 }

import {pageHelper} from '@/utils/pageHelper';
	import SidebarStep5Menu from '@/components/decorations/SidebarStep5Menu';
	import BackLink from '@/components/decorations/BackLink.vue';
	import {computed} from 'vue';
	import {useRoute} from 'vue-router';
	import {useStore} from 'vuex';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarCompany',
  setup(__props) {

	const route = useRoute();
	const store = useStore();
	const companyId = computed(() => route.params.companyId);
	const userIsOwnerForCompany = computed(() => store.getters.isUserCompanyOwner(companyId.value));
	const showCompanyDetailsMenu = computed(() => userIsOwnerForCompany);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _createVNode(BackLink)
      ])
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: { name: _unref(pageHelper).PAGE_COMPANY_IMPROVEMENT_CHECKS_OVERVIEW, params: { companyId: companyId.value }}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Overzicht verbeterchecks ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      (showCompanyDetailsMenu.value.value)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: { name: _unref(pageHelper).PAGE_COMPANY_DETAILS, params: { companyId: companyId.value}}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Bedrijfsgegevens ")
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(SidebarStep5Menu))
  ]))
}
}

})